import request from '@/utils/request'


// 查询商家进件-支付宝直付通列表
export function listExtraApplyAlipay(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家进件-支付宝直付通分页
export function pageExtraApplyAlipay(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家进件-支付宝直付通详细
export function getExtraApplyAlipay(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/detail',
    method: 'get',
    params: data
  })
}

// 新增商家进件-支付宝直付通
export function addExtraApplyAlipay(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/add',
    method: 'post',
    data: data
  })
}

// 修改商家进件-支付宝直付通
export function updateExtraApplyAlipay(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/edit',
    method: 'post',
    data: data
  })
}

export function applyExtraApplyAlipay(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/apply',
    method: 'post',
    data: data
  })
}


// 删除商家进件-支付宝直付通
export function delExtraApplyAlipay(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/alipay/delete',
    method: 'post',
    data: data
  })
}